import { render, staticRenderFns } from "./request-logs.vue?vue&type=template&id=4122f5ad&scoped=true"
import script from "./request-logs.vue?vue&type=script&lang=js"
export * from "./request-logs.vue?vue&type=script&lang=js"
import style0 from "./request-logs.vue?vue&type=style&index=0&id=4122f5ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4122f5ad",
  null
  
)

export default component.exports